// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevPhoneNumberController {
	/* @ngInject */
	constructor() {
		this.settings = {
			placeholder: 'Phone number',
			country: 'FR',
		};
	}
}
